module.exports = __webpack_public_path__ + "static/media/xx.c15ffa45.svg";